import { useState } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { apiClient } from '@/shared/lib/apiClient';
import { Button } from '@/shared/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { Alert, AlertDescription } from '@/shared/components/ui/alert';

export const Route = createFileRoute('/auth/verify-email-sent')({
  component: VerifyEmailSentPage,
});

function VerifyEmailSentPage() {
  const { t } = useTranslation();
  const [resending, setResending] = useState(false);
  const [resentSuccess, setResentSuccess] = useState(false);

  const handleResend = async () => {
    setResending(true);
    setResentSuccess(false);
    try {
      await apiClient.post('/api/v1/auth/resend-verification', {}).catch(() => {});
      setResentSuccess(true);
    } finally {
      setResending(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('auth.verifyEmailSent.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">{t('auth.verifyEmailSent.message')}</p>

        {resentSuccess && (
          <Alert variant="success">
            <AlertDescription>{t('auth.verifyEmailSent.resentSuccess')}</AlertDescription>
          </Alert>
        )}

        <Button
          variant="outline"
          className="w-full"
          isLoading={resending}
          onClick={() => void handleResend()}
        >
          {resending ? t('auth.verifyEmailSent.resending') : t('auth.verifyEmailSent.resend')}
        </Button>

        <p className="text-center">
          <Link to="/auth/login" className="text-sm text-primary hover:underline">
            {t('auth.verifyEmailSent.signIn')}
          </Link>
        </p>
      </CardContent>
    </Card>
  );
}
